import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {
        //用户登录
        login(context, payload) {
            return D.detail(payload).then(response => {
                // const { data } = response.data
                /* context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                }) */
                return response
            })
        },
        loginout(context, payload) {
            return D.detail(payload)
        },
        querysumlog(context, payload) {
            return D.select({
                ...payload
            })
        },
        querysumdata(context, payload) {
            return D.select({
                ...payload
            })
        },
        querylogdashboard(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryAppLogBySys(context, payload) {
            return D.select({
                ...payload
            })
        }
    }
}